export default __webpack_public_path__ + "assets/dashboard-community-4e7158456e8cde1015278dae50249f3a.svg";